import React, { ReactElement } from 'react';

interface FeatureToggleProps {
  active: boolean;
}

export const FeatureToggle: React.FC<FeatureToggleProps> = ({
  active,
  children
}) => {
  if (!children) {
    return null;
  }
  const _children = React.Children.map(children, (child) =>
    React.cloneElement(child as ReactElement, { active })
  );
  return <>{_children}</>;
};

interface OnOffProps {
  active?: boolean;
}
export const On: React.FC<OnOffProps> = ({ active, children }) => (
  <>{active && children}</>
);

export const Off: React.FC<OnOffProps> = ({ active, children }) => (
  <>{!active && children}</>
);
